import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Briefcase,
  Newspaper,
  Building2,
  FileText,
  Mail,
  UserSquare2,
} from "lucide-react";
import api from "../../lib/api";

const CARDS = [
  { key: "projects", label: "Projeler", to: "/admin/projects", Icon: Briefcase },
  { key: "business_units", label: "Faaliyet Alanları", to: "/admin/business-units", Icon: Building2 },
  { key: "news", label: "Haberler", to: "/admin/news", Icon: Newspaper },
  { key: "pages", label: "Sayfalar", to: "/admin/pages", Icon: FileText },
  { key: "contact_submissions", label: "İletişim Formları", to: "/admin/contact-submissions", Icon: Mail },
  { key: "career_applications", label: "Kariyer Başvuruları", to: "/admin/career-openings", Icon: UserSquare2 },
];

const DashboardPage = () => {
  const [stats, setStats] = useState({});
  useEffect(() => {
    api.get("/admin/dashboard/stats").then((r) => setStats(r.data));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="eyebrow eyebrow-gold">Fırat CMS</div>
      <h1 className="display display-md mt-4">Dashboard</h1>
      <p className="mt-4 text-brand-medium max-w-2xl">
        Kurumsal içerik yönetim merkezi. Sitenizin her modülünü buradan yönetin.
      </p>

      <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
        {CARDS.map(({ key, label, to, Icon }) => (
          <Link
            key={key}
            to={to}
            className="bg-white border border-black/5 p-6 md:p-8 hover:border-brand-navy transition-colors group"
            data-testid={`stat-card-${key}`}
          >
            <div className="flex items-center justify-between">
              <Icon size={20} strokeWidth={1.4} className="text-brand-navy" />
              <span className="text-[0.66rem] tracking-[0.28em] uppercase text-brand-medium group-hover:text-brand-gold transition-colors">
                Manage
              </span>
            </div>
            <div className="mt-6 font-serif text-brand-navy" style={{ fontSize: "clamp(2rem, 3.5vw, 3rem)", lineHeight: 1 }}>
              {stats[key] ?? "—"}
            </div>
            <div className="mt-3 text-brand-dark">{label}</div>
          </Link>
        ))}
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white border border-black/5 p-6 md:p-8">
          <div className="eyebrow eyebrow-gold">Inbox</div>
          <div className="mt-4 font-serif text-2xl text-brand-navy">Yeni iletişim mesajları</div>
          <div className="mt-2 text-brand-medium text-sm">
            <span className="text-brand-navy font-medium">{stats.unread_contacts ?? 0}</span> okunmamış mesaj.
          </div>
          <Link to="/admin/contact-submissions" className="link-gold mt-6 inline-flex" data-testid="dashboard-view-contacts">
            İletişim Kutusu →
          </Link>
        </div>
        <div className="bg-white border border-black/5 p-6 md:p-8">
          <div className="eyebrow eyebrow-gold">Careers</div>
          <div className="mt-4 font-serif text-2xl text-brand-navy">Yeni kariyer başvuruları</div>
          <div className="mt-2 text-brand-medium text-sm">
            <span className="text-brand-navy font-medium">{stats.unread_careers ?? 0}</span> yeni başvuru.
          </div>
          <Link to="/admin/career-openings" className="link-gold mt-6 inline-flex" data-testid="dashboard-view-careers">
            Kariyer →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
